/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employee_selfservice_CreateMyCertificateUploadURLBody = {
    /**
     * image/jpeg, image/png or application/pdf
     */
    content_type: employee_selfservice_CreateMyCertificateUploadURLBody.content_type;
    /**
     * File size in bytes, at most 10 MiB
     */
    size_bytes: number;
};
export namespace employee_selfservice_CreateMyCertificateUploadURLBody {
    /**
     * image/jpeg, image/png or application/pdf
     */
    export enum content_type {
        IMAGE_JPEG = 'image/jpeg',
        IMAGE_PNG = 'image/png',
        APPLICATION_PDF = 'application/pdf',
    }
}

